module.exports = __webpack_public_path__ + "img/dryva-screen-2.1b6cedfc.png";